import React from "react";
import PropTypes from "prop-types";
import { CUSTOMISATION_OPTIONS } from "../../constants/all-customisation-options";
import {
  classStringBuilder,
  conditionallyAddStyles,
} from "../../support/helpers";

const propTypes = {
  customisationType: PropTypes.string.isRequired,
  optionName: PropTypes.string.isRequired,
  className: PropTypes.string,
  viewIndex: PropTypes.number,
};

const defaultProps = {
  className: "",
  viewIndex: 0,
};

const WatchImageLayer = ({
  customisationType,
  optionName,
  className,
  viewIndex,
}) => {
  const defaultClasses = ["absolute"];

  const additionalClasses = className.split(" ");

  conditionallyAddStyles(
    viewIndex === 0,
    additionalClasses,
    "max-h-full",
    "max-h-x2"
  );

  conditionallyAddStyles(
    customisationType === "seconds",
    additionalClasses,
    "seconds-hand"
  );

  const classes = classStringBuilder(defaultClasses, additionalClasses);

  return (
    <>
      {optionName !== "none" && (
        <img
          src={
            CUSTOMISATION_OPTIONS[customisationType].options[optionName]
              .watchLayerAsset
          }
          alt={optionName}
          className={classes}
        />
      )}
    </>
  );
};

WatchImageLayer.propTypes = propTypes;

WatchImageLayer.defaultProps = defaultProps;

export default WatchImageLayer;
